import { Reveal, Overline } from "@/components/Reveal";

const questions = [
  "Was ist erlaubt?",
  "Wo entstehen Datenschutzrisiken?",
  "Und wie lässt sich die DSGVO so umsetzen, dass Datenschutz die tägliche Arbeit unterstützt, statt sie unnötig kompliziert zu machen?",
];

const Problem = () => (
  <section
    id="relevanz"
    data-testid="problem-section"
    className="relative py-24 sm:py-32 border-t border-white/5"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <Overline>Problem &amp; Relevanz</Overline>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mt-4">
            Datenschutz gehört zum Einsatzalltag.
          </h2>
          <p className="mt-6 text-base md:text-lg text-gray-400 leading-relaxed">
            Bei Feuerwehr, Rettungsdienst, THW und Hilfsorganisationen geht es
            um Menschen, Verantwortung und Vertrauen. Gleichzeitig werden jeden
            Tag personenbezogene Daten verarbeitet: bei Einsätzen, in der
            Leitstelle, in Mitgliederverwaltungen, bei Fotos und Videos, in
            Messenger-Gruppen, auf Social Media oder bei der Zusammenarbeit mit
            anderen Organisationen.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {questions.map((q, i) => (
          <Reveal key={q} delay={i * 0.12}>
            <div
              data-testid={`problem-question-${i + 1}`}
              className="card-glow h-full rounded-xl border border-blau/20 bg-navy-800/70 p-7 transition-shadow duration-300"
            >
              <span className="font-mono text-xs text-blau-glow tracking-[0.2em]">
                0{i + 1}
              </span>
              <p className="mt-4 text-base md:text-lg font-semibold text-white leading-snug">
                {q}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-14 text-xl sm:text-2xl font-display font-bold text-white max-w-3xl">
          BlaulichtPraxis{" "}
          <span className="text-blau">
            übersetzt Datenschutz in die Sprache der Praxis.
          </span>
        </p>
      </Reveal>
    </div>
  </section>
);

export default Problem;
